"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/disclosure/disclosure-store.ts
var _disclosurestore = require('@ariakit/core/disclosure/disclosure-store'); var Core = _interopRequireWildcard(_disclosurestore);
function useDisclosureStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.store, props.disclosure]);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "open", "setOpen");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "mounted", "setMounted");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "animated");
  return Object.assign(store, { disclosure: props.disclosure });
}
function useDisclosureStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createDisclosureStore, props);
  return useDisclosureStoreProps(store, update, props);
}




exports.useDisclosureStoreProps = useDisclosureStoreProps; exports.useDisclosureStore = useDisclosureStore;
